exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".box[data-v-7d4940f0]{position:absolute;top:0;left:0;z-index:1}.box[data-v-7d4940f0],.mm-alert[data-v-7d4940f0]{width:100%}", ""]);

// exports
